<div class="container rtl iran-sans" data-aos="fade-up">

    <div class="section-title">
        <h2 class="mb-3">خدمات</h2>
        <p>
            خدمات ارائه شده ما را در دکتر می دنبال کنید.
        </p>
    </div>

    <div class="row">
        <div class="col-md-6 col-lg-3 d-flex align-items-stretch" data-aos="zoom-in" data-aos-delay="100"
            (click)="onSchedule()">
            <div class="icon-box">
                <div class="icon"><i class="bx bx-calendar"></i></div>
                <h4 class="title"><a href="http://apt.drme.ir">جستجوی پزشک و نوبت دهی</a></h4>
                <p class="description">
                    امکان جستجوی پزشکان در سراسر کشور و دریافت نوبت اینترنتی برای مراجعه حضوری به مطب از این طریق فراهم
                    شده است.
                </p>
            </div>
        </div>

        <div class="col-md-6 col-lg-3 d-flex align-items-stretch" data-aos="zoom-in" data-aos-delay="200">
            <div class="icon-box">
                <div class="icon"><i class="bx bx-blanket"></i></div>
                <h4 class="title"><a href="">مشاوره و ویزیت آنلاین</a></h4>
                <p class="description">
                    دریافت مشاوره و ویزیت از پزشکان به صورت غیرحضوری از خدمات آنلاین سلامت می‌باشد. برای این منظور ابتدا
                    باید پزشک خود را انتخاب نمایید.
                </p>
            </div>
        </div>

        <div class="col-md-6 col-lg-3 d-flex align-items-stretch" data-aos="zoom-in" data-aos-delay="300"
            (click)="onPresc()">
            <div class="icon-box">
                <div class="icon"><i class="bx bx-first-aid"></i></div>
                <h4 class="title"><a href="http://ep.drme.ir">پرونده الکترونیک سلامت</a></h4>
                <p class="description">
                    این قابلیت فراهم شده است تا هر فرد، دسترسی به پرونده سلامت خود داشته باشد و از اقدامات تشخیصی و
                    درمانی انجام شده مطلع باشد.
                </p>
            </div>
        </div>

        <div class="col-md-6 col-lg-3 d-flex align-items-stretch" data-aos="zoom-in" data-aos-delay="400">
            <div class="icon-box">
                <div class="icon"><i class="bx bx-share-alt"></i></div>
                <h4 class="title"><a href="">اشتراک تجربه بیماران</a></h4>
                <p class="description">
                    بیماران می توانند با اشتراک گذاشتن نظرات خود در مورد بیماری، از وضعیت سایر بیماران و راهنمایی های
                    پزشکان استفاده نمایند.
                </p>
            </div>
        </div>

    </div>
</div>